import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user p-mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!

  return (_openBlock(), _createBlock(_component_AutoComplete, _mergeProps(_ctx.$attrs, {
    dropdown: "",
    completeOnFocus: "",
    modelValue: _ctx.searchBox,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.searchBox = $event)),
    suggestions: _ctx.suggestions,
    field: _ctx.fieldFn,
    minLength: 2,
    placeholder: "Cerca utente",
    onItemSelect: _ctx.onSelect,
    onComplete: _ctx.search,
    onChange: _ctx.onChange
  }), {
    item: _withCtx(({item}) => [
      _hoisted_1,
      _createElementVNode("span", null, _toDisplayString(item.name) + " " + _toDisplayString(item.surname), 1)
    ]),
    _: 1
  }, 16, ["modelValue", "suggestions", "field", "onItemSelect", "onComplete", "onChange"]))
}